(function () {
  const STORAGE_KEY = "xo_cart_discount_code";

  // -------------------------
  // STORAGE
  // -------------------------
  function saveDiscount(code) {
    if (!code) return;
    localStorage.setItem(STORAGE_KEY, code);
  }

  function removeDiscount() {
    localStorage.removeItem(STORAGE_KEY);
  }

  function getDiscount() {
    return localStorage.getItem(STORAGE_KEY);
  }

  // -------------------------
  // UI RENDER (MOST IMPORTANT FIX)
  // -------------------------
  function renderDiscountUI() {
    const code = getDiscount();

    document
      .querySelectorAll(".xo-cart-mini-footer__discount, .discounts__discount")
      .forEach(el => {
        el.style.display = code ? "" : "none";
      });

    const input = document.querySelector("input[name='discount']");
    if (input && code) {
      input.value = code;
    }
  }

  // -------------------------
  // CART REFRESH
  // -------------------------
  function refreshCart() {
    fetch("/cart.js", {
      credentials: "same-origin"
    })
      .then(res => res.json())
      .then(() => {
        document.dispatchEvent(new CustomEvent("cart:refresh"));

        // 🔥 re-apply UI after Shopify re-render
        setTimeout(renderDiscountUI, 200);
      });
  }

  // -------------------------
  // APPLY DISCOUNT (NO REDIRECT)
  // -------------------------
  function applyDiscount(code) {
    saveDiscount(code);

    fetch(`/discount/${code}?redirect=/cart`, {
      method: "GET",
      credentials: "same-origin"
    })
      .then(() => {
        refreshCart();
        setTimeout(renderDiscountUI, 300);
      })
      .catch(err => console.error("Apply error:", err));
  }

  // -------------------------
  // REMOVE DISCOUNT (NO REFRESH ISSUE)
  // -------------------------
  function removeDiscountFlow() {
    removeDiscount();

    document
      .querySelectorAll(".xo-cart-mini-footer__discount, .discounts__discount")
      .forEach(el => (el.style.display = "none"));

    refreshCart();
  }

  // -------------------------
  // CLICK HANDLER
  // -------------------------
  document.addEventListener("click", function (e) {
    const saveBtn = e.target.closest(".xo-cart-discount__btn-add");
    const removeBtn = e.target.closest(".remove-discount-btn");

    // APPLY
    if (saveBtn) {
      e.preventDefault();

      const input = document.querySelector("input[name='discount']");
      const code = input ? input.value.trim() : "";

      if (!code) return;

      applyDiscount(code);
      return;
    }

    // REMOVE
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();

      removeDiscountFlow();
      return;
    }
  });

  // -------------------------
  // INIT (PAGE LOAD FIX)
  // -------------------------
  document.addEventListener("DOMContentLoaded", function () {
    renderDiscountUI();
  });

  // -------------------------
  // EXTRA SAFETY: Shopify cart re-render hook
  // -------------------------
  document.addEventListener("cart:refresh", function () {
    renderDiscountUI();
  });
})();